import {NotificationItem} from '../model/types';

const NOT_SUBSCRIPTION_NOTIFICATIONS_TYPES: NotificationItem['type'][] = [
  'visit',
  'smashUserInvisible',
];

export function subscriptionNotificationType(type: NotificationItem['type']) {
  return !NOT_SUBSCRIPTION_NOTIFICATIONS_TYPES.includes(type);
}
